import type { ManagerRole } from '../api/managerApi';
import type { AppRoute, AppRouteId } from '../routes/appRoutes';

export const ALL_MANAGER_ROLES = ['SUPER', 'MIDDLE', 'GENERAL'] as const;
export const PRIVILEGED_MANAGER_ROLES = ['SUPER', 'MIDDLE'] as const;
export const SUPER_MANAGER_ROLES = ['SUPER'] as const;

const routeRoles: Partial<Record<AppRouteId, readonly ManagerRole[]>> = {
  'device-management': PRIVILEGED_MANAGER_ROLES,
  'notice-management': PRIVILEGED_MANAGER_ROLES,
  'b2b-inquiry-management': PRIVILEGED_MANAGER_ROLES,
  'qna-management': PRIVILEGED_MANAGER_ROLES,
  'certificate-template': PRIVILEGED_MANAGER_ROLES,
  'homepage-user-management': PRIVILEGED_MANAGER_ROLES,
  'goods-representative-image': PRIVILEGED_MANAGER_ROLES,
  'user-management': SUPER_MANAGER_ROLES,
  'timing-points': ALL_MANAGER_ROLES,
  categories: ALL_MANAGER_ROLES,
  splits: ALL_MANAGER_ROLES,
  'event-reader-devices': ALL_MANAGER_ROLES,
  'raw-data': ALL_MANAGER_ROLES,
};

export function canAccessHomepageManagement(role: ManagerRole | null) {
  return role === 'SUPER' || role === 'MIDDLE';
}

export function canAccessRoute(route: AppRoute, role: ManagerRole | null) {
  if (route.section === 'auth') {
    return true;
  }

  const allowedRoles = routeRoles[route.id];
  if (!allowedRoles) {
    return true;
  }

  return role !== null && allowedRoles.includes(role);
}

export function filterRoutesByRole(routes: AppRoute[], role: ManagerRole | null) {
  return routes.filter((route) => canAccessRoute(route, role));
}
